import type { LeagueNavigateOptions, LeagueTo as To } from '../router-types';
import { restoreV5RelativeTo, getRouterAdapter } from '../utils';

/**
 * Wrapper around react-router-dom's useNavigate hook that ensures all `to`s are treated
 * as absolute. Helps bridge between v5 APIs, which (more or less) treats all `to`s
 * as absolute, and v6 APIs, which treats `to`s without a leading slash as relative.
 */
export const useNavigateLegacy = () => {
  const navigate = getRouterAdapter().useNavigate();
  const { pathname } = getRouterAdapter().useLocation();

  const ourNavigate = (to: To, options?: LeagueNavigateOptions) => {
    if (typeof to === 'number') {
      navigate(to);
    } else {
      navigate(restoreV5RelativeTo(to, pathname), {
        relative: 'path',
        ...options,
      });
    }
  };

  return ourNavigate as typeof navigate;
};
